import firebase from 'firebase'

const config = {
    apiKey: 'AIzaSyBF64nlSg3eJRyuJDZ_yuySIwaREifymwg',
    authDomain: 'anyhazard.firebaseapp.com',
    databaseURL: 'https://anyhazard.firebaseio.com',
    projectId: 'anyhazard',
    storageBucket: 'anyhazard.appspot.com',
    messagingSenderId: '70846509654',
}

firebase.initializeApp(config)
export default firebase



// WEBPACK FOOTER //
// ./src/firebase.js